
  window.shopUrl = 'https://biolgical.com/products/aughs-leaky-gut-protocol';
  window.routes = {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart',
    cart_clear_url: '/cart/clear',
    predictive_search_url: '/search/suggest',
  };

  window.cartStrings = {
    error: `There was an error while updating your cart. Please try again.`,
    quantityError: `You can only add [quantity] of this item to your cart.`,
  };

  window.variantStrings = {
    addToCart: `Add to cart`,
    soldOut: `Sold out`,
    unavailable: `Unavailable`,
    unavailable_with_option: `[value] - Unavailable`,
  };

  window.quickOrderListStrings = {
    itemsAdded: `[quantity] items added`,
    itemAdded: `[quantity] item added`,
    itemsRemoved: `[quantity] items removed`,
    itemRemoved: `[quantity] item removed`,
    viewCart: `View cart`,
    each: `[money]/ea`,
    min_error: `This item has a minimum of [min]`,
    max_error: `This item has a maximum of [max]`,
    step_error: `You can only add this item in increments of [step]`,
  };

  window.accessibilityStrings = {
    imageAvailable: `Image [index] is now available in gallery view`,
    shareSuccess: `Link copied to clipboard`,
    pauseSlideshow: `Pause slideshow`,
    playSlideshow: `Play slideshow`,
    recipientFormExpanded: `Gift card recipient form expanded`,
    recipientFormCollapsed: `Gift card recipient form collapsed`,
    countrySelectorSearchCount: `[count] countries/regions found`,
  };